import React, { FC, useEffect, useMemo, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import Select from 'react-select';
import { fetchData, fetchFormData, getTranslatedValue, hasSpecialCharacters, toasterrormsg, toastsuccessmsg } from '../../../../reusable';
import { ToastContainer } from 'react-toastify';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import PriceInput from '../../PriceInput';
import { Tr } from '../../../../_metronic/i18n/Tr';
import { useLang } from '../../../../_metronic/i18n/Metronici18n';

const AddCarCoupon: FC = () => {

  const t = Tr()
  const lang = useLang()
  const categoryId = sessionStorage.getItem('categoryId') || '';

  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
    var vendor = JSON.parse(vendorData);
    vendorId = vendor.vendorId;

  } else {
    console.log("No vendor data found");
  }
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false);
  const location = useLocation();
  const editCouponId = (location.state as any)?.couponId || '';

  const [offerTitleEN, setOfferTitleEN] = useState("");
  const [offerTitleRU, setOfferTitleRU] = useState("");
  const [offerTitleUZ, setOfferTitleUZ] = useState("");
  const [image, setImage] = useState()
  const [imageUrl, setImageUrl] = useState("");
  const [fromCouponPeriod, setFromCouponPeriod] = useState<any>({
    date: ''
  });

  const [toCouponPeriod, setToCouponPeriod] = useState<any>({
    date: ''
  });
  const [couponCode, setCouponCode] = useState("");
  // coupon type state
  const couponTypeList = useMemo(() => [
    { label: t('Percentage'), value: 'PERCENTAGE' },
    { label: t('Fixed'), value: 'FIXED' }
  ], [t]);
  const [couponTypeSelectedOptions, setCouponTypeSelectedOptions] = useState<any>('FIXED');
  const [couponValue, setCouponValue] = useState("");
  const [minimumAmount, setMinimumAmount] = useState("");
  const [maximumAmount, setMaximumAmount] = useState("");
  const [propertyList, setProperyList] = useState([]);
  const [propertyId, setPropertyId] = useState("");
  // car type list state start
  const [carTypeList, setCarTypeList] = useState([]);
  const [carTypeSelectedOptions, setCarTypeSelectedOptions] = useState<any>([]);
  const carTypeId = carTypeSelectedOptions ? carTypeSelectedOptions.map((option: any) => option.value).join(',') : "";
  const [limitPerUser, setLimitPerUser] = useState("");
  const [limitPerCoupon, setLimitPerCoupon] = useState("");
  // car type list state end
  // car type list api call
  const carTypeListAPIcall = async (propertyId:any) => {

    const param = {
      categoryId: categoryId,
      vendorId: vendorId,
      actionId:propertyId
    }
    var res = await fetchData("public/vendorWiseInventoryTypes", param)

    if (res.status == "200") {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.carcategoryId, label: getTranslatedValue(lang, val, '_name') })
      })
      console.log(res.data);
      
      setCarTypeList(opt)
    }
    else {
      toasterrormsg(res.message)
    }
  }
  // set error state
  const [error, setError] = useState([{
    offerTitleEN: '',
    offerTitleRU: '',
    offerTitleUZ: '',
    image: '',
    couponCode: '',
    fromCouponPeriod: '',
    toCouponPeriod: '',
    couponType: '',
    couponValue: '',
    propertyId: '',
    carTypeId: '',
    minimumAmount: '',
    maximumAmount: '',
    limitPerUser: '',
    limitPerCoupon: '',
  }])

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any;
    tmp[0][err] = "";
    setError(tmp);
  }

  // validation function
  const validate = () => {

    var isValid = true;
    var errorTmp = [...error];
    if ((image == null || image == undefined) && (imageUrl === "" || imageUrl === null)) {
      errorTmp[0].image = t('Image Is Required');
      isValid = false;
    }
    if (offerTitleEN.trim() == "" || offerTitleEN.trim() == null || offerTitleEN.trim() == undefined) {
      errorTmp[0].offerTitleEN = t('Offer Title Is Required');
      isValid = false;
    }
    if (offerTitleRU.trim() == "" || offerTitleRU.trim() == null || offerTitleRU.trim() == undefined) {
      errorTmp[0].offerTitleRU = t('Offer Title Is Required');
      isValid = false;
    }
    if (offerTitleUZ.trim() == "" || offerTitleUZ.trim() == null || offerTitleUZ.trim() == undefined) {
      errorTmp[0].offerTitleUZ = t('Offer Title Is Required');
      isValid = false;
    }
    if (couponCode.trim() == "" || couponCode.trim() == null || couponCode.trim() == undefined) {
      errorTmp[0].couponCode = t('Coupon Code Is Required');
      isValid = false;
    } else if (!hasSpecialCharacters(couponCode.trim())) {
      errorTmp[0].couponCode = t('Special Characters Is Not Allow');
      isValid = false;
    }
    if (fromCouponPeriod.date == "" || fromCouponPeriod.date == null || fromCouponPeriod.date == undefined) {
      errorTmp[0].fromCouponPeriod = t('Coupon Period Is Required');
      isValid = false;
    }
    if (toCouponPeriod.date == "" || toCouponPeriod.date == null || toCouponPeriod.date == undefined) {
      errorTmp[0].toCouponPeriod = t('Coupon Period Is Required');
      isValid = false;
    } else if (toCouponPeriod.date <= fromCouponPeriod.date) {
      errorTmp[0].toCouponPeriod = t('End Date Must Be Greater Then Start Date');
      isValid = false;
    }
    if (couponTypeSelectedOptions == undefined || couponTypeSelectedOptions == null || couponTypeSelectedOptions == "") {
      errorTmp[0].couponType = t('Coupon Type Is Required');
      isValid = false;
    }
    if (propertyId == undefined || propertyId == null || propertyId == "") {
      errorTmp[0].propertyId = t('Property Is Required');
      isValid = false;
    }
    if (carTypeSelectedOptions.length == 0) {
      errorTmp[0].carTypeId = t('Car Type Is Required');
      isValid = false;
    }
    if (couponTypeSelectedOptions == 'FIXED') {
      if (couponValue == "" || couponValue == null || couponValue == undefined) {
        errorTmp[0].couponValue = t('Coupon Value Is Required');
        isValid = false;
      } else if (!hasSpecialCharacters(couponValue)) {
        errorTmp[0].couponValue = t('Special Characters Is Not Allow');
        isValid = false;
      } else if (parseFloat(couponValue) <= 0) {
        errorTmp[0].couponValue = t('Coupon Value Must Be Greater Then 0');
        isValid = false;
      }
    } else if (couponTypeSelectedOptions == 'PERCENTAGE') {
      if (couponValue == "" || couponValue == null || couponValue == undefined) {
        errorTmp[0].couponValue = t('Coupon Value Is Required');
        isValid = false;
      } else if (!Number.isInteger(parseFloat(couponValue))) {
        errorTmp[0].couponValue = t('Coupon Value Must Be Valid Number');
        isValid = false;
      } else if (parseFloat(couponValue) > 100) {
        errorTmp[0].couponValue = t('Coupon Value Must Be Less Then Or Equal To 100');
        isValid = false;
      } else if (parseFloat(couponValue) <= 0) {
        errorTmp[0].couponValue = t('Coupon Value Must Be Greater Then 0');
        isValid = false;
      }
    }
    if (minimumAmount == "" || minimumAmount == null || minimumAmount == undefined) {
      errorTmp[0].minimumAmount = t('Minimum Amount Is Required');
      isValid = false;
    } else if (!hasSpecialCharacters(minimumAmount)) {
      errorTmp[0].minimumAmount = t('Special Characters Is Not Allow');
      isValid = false;
    }
    if (couponTypeSelectedOptions == 'PERCENTAGE') {
      if (maximumAmount == "" || maximumAmount == null || maximumAmount == undefined) {
        errorTmp[0].maximumAmount = t('Maximum Amount Is Required');
        isValid = false;
      } else if (!hasSpecialCharacters(maximumAmount)) {
        errorTmp[0].maximumAmount = t('Special Characters Is Not Allow');
        isValid = false;
      }
    }
    if (limitPerUser == "" || limitPerUser == null || limitPerUser == undefined) {
      errorTmp[0].limitPerUser = t('Limit Per User Is Required');
      isValid = false;
    } else if (!hasSpecialCharacters(limitPerUser)) {
      errorTmp[0].limitPerUser = t('Special Characters Is Not Allow');
      isValid = false;
    } else if (parseFloat(limitPerUser) <= 0) {
      errorTmp[0].limitPerUser = t('Limit Per User Must Be Greater Then 0');
      isValid = false;
    } else if (parseFloat(limitPerUser) > parseFloat(limitPerCoupon)) {
      errorTmp[0].limitPerUser = t('Limit Per User Must Be Less Then Limit Per Coupon');
      isValid = false;
    }
    if (limitPerCoupon == "" || limitPerCoupon == null || limitPerCoupon == undefined) {
      errorTmp[0].limitPerCoupon = t('Limit Per Coupon Is Required');
      isValid = false;
    } else if (!hasSpecialCharacters(limitPerCoupon)) {
      errorTmp[0].limitPerCoupon = t('Special Characters Is Not Allow');
      isValid = false;
    } else if (parseFloat(limitPerCoupon) <= 0) {
      errorTmp[0].limitPerCoupon = t('Limit Per Coupon Must Be Greater Then 0');
      isValid = false;
    }

    setError(errorTmp);
    return isValid;
  }

  // save coupon api call
  const saveCouponApiCall = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true)
      let param = new FormData()
      if (editCouponId) {
        param.append('couponId', editCouponId)
      }
      param.append('vendorId', vendorId)
      param.append('categoryId', categoryId)
      param.append('en_offertitle', offerTitleEN)
      param.append('ru_offertitle', offerTitleRU)
      param.append('uz_offertitle', offerTitleUZ)
      if (image) {
        param.append('image', image);
      }
      param.append('from', fromCouponPeriod.date)
      param.append('to', toCouponPeriod.date)
      param.append('couponCode', couponCode)
      param.append('couponType', couponTypeSelectedOptions)
      param.append('couponValue', couponValue)
      param.append('miniAmount', minimumAmount)
      param.append('maxAmount', maximumAmount)
      param.append('limitPerUser', limitPerUser)
      param.append('limitPerCoupon', limitPerCoupon)
      param.append('actionId', propertyId)
      param.append('typeId', carTypeId)

      var res = await fetchFormData("public/addEditCoupon", param)

      if (res.status == "200") {
        toastsuccessmsg(t("Coupon Saved Successfully!"))
        setTimeout(() => {
          setDisable(false)
          setLoading(false);
          navigate('../viewcarcouponlist/');
        }, 1500);
      }
      else {
        setLoading(false);
        toasterrormsg(res.message)
        setDisable(false)
      }
    }
  }
  const carrenatlListAPIcall = async () => {
    var param = {
      'vendorId': String(vendorId)
    }
    var res = await fetchData("public/carRentalList", param)

    if (res.status == "200") {
      var data = res.data;
      var opt: any = []
      data.map((val: any) => {
        opt.push({ value: val.carrentalId, label: getTranslatedValue(lang, val, '_supplierName') })
      })
      setProperyList(opt)
    }
    else {
      toasterrormsg(res.message)
    }
  }
  useEffect(() => {
    carrenatlListAPIcall()
  }, [])
  useEffect(() => {
    if(propertyId){
      carTypeListAPIcall(propertyId)
    }
  }, [propertyId])
  const couponDetailsApiCall = async () => {
    var param: any = {
      couponId: String(editCouponId),
    }
    var response: any = await fetchData("public/couponDetail", param)

    if (response.status == "200") {
      var data = response.data[0]
      setOfferTitleEN(data['en_offertitle'])
      setOfferTitleRU(data['ru_offertitle'])
      setOfferTitleUZ(data['uz_offertitle'])
      setImageUrl(data['image'])
      setFromCouponPeriod({ date: data['from'] })
      setToCouponPeriod({ date: data['to'] })
      setCouponCode(data['couponCode'])
      if (data['couponType'] == "PERCENTAGE") {
        setCouponTypeSelectedOptions('PERCENTAGE')
        setMaximumAmount(data['maxAmount'])
      } else if (data['couponType'] == "FIXED") {
        setCouponTypeSelectedOptions('FIXED')
      }
      setMinimumAmount(data['miniAmount'])
      var tourType: any = []
      data.typeDetail.map((val: any) => {
        tourType.push({ value: val.carcategoryId, label: getTranslatedValue(lang, val, '_name') })
      })
      setCarTypeSelectedOptions(tourType.length > 0 ? tourType : [])
      setLimitPerUser(data['limitPerUser'])
      setLimitPerCoupon(data['limitPerCoupon'])
      setCouponValue(data['couponValue'])
      setPropertyId(data['actionId'])
    }
    else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (editCouponId) {
      couponDetailsApiCall()
    }
  }, [editCouponId])

  useEffect(() => {
    if (categoryId != '7') {
      navigate('../dashboard/');
    }
  }, [categoryId])
  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('Coupon Management')}</PageTitle>
      <div className="d-flex flex-column flex-column-fluid">
        {/* <!--begin::Content--> */}
        <div id="kt_app_content" className="app-content flex-column-fluid">
          {/* <!--begin::Form--> */}
          <div className="form d-flex flex-column flex-lg-row">
            {/* <!--begin::Main column--> */}
            <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
              {/* <!--begin::Tab content--> */}
              <div className="tab-content">
                {/* <!--begin::Tab pane--> */}
                <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">

                  <div className="d-flex flex-column">
                    {/* <!--begin::General options--> */}
                    <div className="card card-flush py-4">
                      {/* <!--begin::Card header--> */}
                      <div className="card-header d-flex">
                        {/* <!--begin::Card title--> */}
                        <div className="card-title">
                          <h2>{t('Add Coupon')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                      </div>
                      {/* <!--end::Card header--> */}
                      {/* <!--begin::Card body--> */}
                      <div className="card-body pt-10">
                        {/* <!--begin::Input group--> */}
                        <div className="row">
                          <div className="col-lg-4 my-3">
                            {/* <!--begin::Label--> */}
                            <label className="required fs-4 form-label">{t('Offer Title (English)')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input type="text" name="offerTitleEN" className="form-control mb-2" placeholder={t("Offer Title")} value={offerTitleEN} onChange={(e) => { setOfferTitleEN(e.target.value); removeError("offerTitleEN"); }} />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].offerTitleEN}</div>
                          </div>
                          <div className="col-lg-4 my-3">
                            {/* <!--begin::Label--> */}
                            <label className="required fs-4 form-label">{t('Offer Title (Russian)')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input type="text" name="offerTitleRU" className="form-control mb-2" placeholder={t("Offer Title")} value={offerTitleRU} onChange={(e) => { setOfferTitleRU(e.target.value); removeError("offerTitleRU"); }} />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].offerTitleRU}</div>
                          </div>
                          <div className="col-lg-4 my-3">
                            {/* <!--begin::Label--> */}
                            <label className="required fs-4 form-label">{t('Offer Title (Uzbek)')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input type="text" name="offerTitleUZ" className="form-control mb-2" placeholder={t("Offer Title")} value={offerTitleUZ} onChange={(e) => { setOfferTitleUZ(e.target.value); removeError("offerTitleUZ"); }} />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].offerTitleUZ}</div>
                          </div>
                          <div className="col-lg-12 my-3">
                            <label className="required fs-4 form-label">{t('Offer Image')}</label>
                            <br />
                            {/* <!--begin::Image input--> */}
                            <div className="image-input image-input-outline " data-kt-image-input="true">

                              {/* <!--begin::Preview existing avatar--> */}

                              <img id="previewImage" className="image-input-wrapper w-125px h-125px changeimg pointer" src={image ? URL.createObjectURL(image) : imageUrl === "" || imageUrl === null ? toAbsoluteUrl("/media/logos/InsayrLogo.png") : imageUrl} />

                              {/* <!--end::Preview existing avatar--> */}
                              {/* <!--begin::Label--> */}
                              <label className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="change" data-bs-toggle="tooltip" title="" data-bs-original-title="Change avatar">
                                <i className="fa fa-edit"></i>
                                {/* <!--begin::Inputs--> */}
                                <input type="file" name="image" id="profileImage" accept=".png, .jpg, .jpeg" style={{ "display": "none" }} onChange={(e: any) => { if (e.target.files[0] != null && e.target.files[0] != undefined) { setImage(e.target.files[0]); removeError("image") } }} />
                                <input type="hidden" name="avatar_remove" />
                                {/* <!--end::Inputs--> */}
                              </label>
                              {/* <!--end::Label--> */}
                            </div>
                            {/* <!--end::Image input--> */}
                            {/* <!--begin::Hint--> */}
                            <div className="form-text" id="validimage">{t('Allowed file types: png, jpg, jpeg.')}</div>
                            {/* <!--end::Hint--> */}
                            <div className='text-danger fw-bold'>{error[0].image}</div>
                          </div>
                          <div className="col-lg-8 my-3">
                            {/* <!--begin::Label--> */}
                            <label className="required fs-4 form-label">{t('Coupon Period')}</label>
                            {/* <!--end::Label--> */}
                            <div className="row">
                              <div className="col-lg">
                                <Flatpickr
                                  value={fromCouponPeriod.date}
                                  onChange={([date]) => {
                                    setFromCouponPeriod({ date }); removeError('fromCouponPeriod');
                                  }}
                                  options={{
                                    enableTime: true,
                                    dateFormat: "d-m-Y H:i",
                                    minDate: new Date().setHours(0, 0, 0, 0)
                                  }}
                                  className='form-control mb-2'
                                  placeholder={t('Pick datetime')}
                                />
                                <div className='text-danger fw-bold'>{error[0].fromCouponPeriod}</div>
                              </div>
                              <div className="col-lg-1 d-flex align-items-center justify-content-center">
                                <label className="fs-3 form-label">{t('To')}</label>
                              </div>
                              <div className="col-lg">
                                <Flatpickr
                                  value={toCouponPeriod.date}
                                  onChange={([date]) => {
                                    setToCouponPeriod({ date }); removeError('toCouponPeriod');
                                  }}
                                  options={{
                                    enableTime: true,
                                    dateFormat: "d-m-Y H:i",
                                    minDate: new Date().setHours(0, 0, 0, 0)
                                  }}
                                  className='form-control mb-2'
                                  placeholder={t('Pick datetime')}
                                />
                                <div className='text-danger fw-bold'>{error[0].toCouponPeriod}</div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4 my-3">
                            {/* <!--begin::Label--> */}
                            <label className="required fs-4 form-label">{t('Coupon Code')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input type="text" name="couponCode" className="form-control mb-2" placeholder={t("Coupon Code")} value={couponCode} onChange={(e) => { setCouponCode(e.target.value); removeError('couponCode') }} />
                            <div className='text-danger fw-bold'>{error[0].couponCode}</div>
                            {/* <!--end::Input--> */}
                          </div>
                          <div className="col-lg-4 my-3">
                            {/* <!--begin::Label--> */}
                            <label className="required fs-4 form-label">{t('Coupon Type')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <Select
                              name='couponType[]'
                              id='couponType'
                              placeholder={t('Select Coupon Type')}
                              isSearchable={true}
                              options={couponTypeList}
                              value={couponTypeList.find(opt => opt.value == couponTypeSelectedOptions)}
                              onChange={(e: any) => { setCouponTypeSelectedOptions(e.value); removeError('couponType') }}
                            />
                            <div className='text-danger fw-bold'>{error[0].couponType}</div>
                            {/* <!--end::Input--> */}
                          </div>
                        </div>
                        <div className="row">
                          {
                            couponTypeSelectedOptions && couponTypeSelectedOptions == "FIXED" && (
                              <div className="col-lg-4 my-3">
                                <PriceInput
                                  labelClass="required fs-4 form-label"
                                  label={t("Coupon Value")}
                                  inputClass="form-control mb-2 border-right-0"
                                  placeholder={t("Coupon Value")}
                                  value={couponValue}
                                  onChange={(e: any) => { setCouponValue(e); removeError("couponValue"); }}
                                />
                                <div className='text-danger fw-bold'>{error[0].couponValue}</div>
                                {/* <!--end::Input--> */}
                              </div>
                            )
                          }{
                            couponTypeSelectedOptions && couponTypeSelectedOptions == "PERCENTAGE" && (
                              <div className="col-lg-4 my-3">
                                {/* <!--begin::Label--> */}
                                <label className="required fs-4 form-label">{t('Coupon Value (%)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input type="number" name="couponValue" className="form-control mb-2" min={1} placeholder={t("Coupon Value (%)")} value={couponValue} onChange={(e) => { setCouponValue(e.target.value); removeError("couponValue"); }} />
                                <div className='text-danger fw-bold'>{error[0].couponValue}</div>
                                {/* <!--end::Input--> */}
                              </div>
                            )
                          }
                          <div className="col-lg-4 my-3">
                            <PriceInput
                              labelClass="required fs-4 form-label"
                              label={t("Minimum Purchase Amount")}
                              inputClass="form-control mb-2 border-right-0"
                              placeholder={t("Minimum Purchase Amount")}
                              value={minimumAmount}
                              onChange={(e: any) => { setMinimumAmount(e); removeError("minimumAmount"); }}
                            />
                            <div className='text-danger fw-bold'>{error[0].minimumAmount}</div>
                            {/* <!--end::Input--> */}
                          </div>
                          {
                            couponTypeSelectedOptions && couponTypeSelectedOptions == "PERCENTAGE" && (
                              <div className="col-lg-4 my-3">
                                <PriceInput
                                  labelClass="required fs-4 form-label"
                                  label={t("Maximum Discount Amount")}
                                  inputClass="form-control mb-2 border-right-0"
                                  placeholder={t("Maximum Discount Amount")}
                                  value={maximumAmount}
                                  onChange={(e: any) => { setMaximumAmount(e); removeError("maximumAmount"); }}
                                />
                                <div className='text-danger fw-bold'>{error[0].maximumAmount}</div>
                                {/* <!--end::Input--> */}
                              </div>
                            )
                          }
                        </div>
                        <div className="row">
                          <div className="col-lg-4 my-3">
                            {/* <!--begin::Label--> */}
                            <label className="required fs-4 form-label">{t('Property')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <Select
                              name='property[]'
                              id='property'
                              placeholder={t('Select Property')}
                              isSearchable={true}
                              options={propertyList}
                              value={propertyList.find((opt: any) => opt.value == propertyId)}
                              onChange={(e: any) => { setPropertyId(e.value); setCarTypeSelectedOptions([]); removeError('propertyId'); removeError('carTypeId'); }}
                            />
                            <div className='text-danger fw-bold'>{error[0].propertyId}</div>
                            {/* <!--end::Input--> */}
                          </div>
                          <div className="col-lg-4 my-3">
                            {/* <!--begin::Label--> */}
                            <label className="required fs-5 form-label">{t('Car Type')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <Select
                              name='carType[]'
                              id='carTypeListId'
                              placeholder={t('Select Car Type')}
                              isSearchable={true}
                              options={carTypeList}
                              isMulti
                              value={carTypeSelectedOptions}
                              onChange={(e: any) => { setCarTypeSelectedOptions(e); removeError("carTypeId"); }}
                            />
                            <div className='text-danger fw-bold'>{error[0].carTypeId}</div>
                            {/* <!--end::Input--> */}
                          </div>
                          <div className="col-lg-4 my-3">
                            {/* <!--begin::Label--> */}
                            <label className="required fs-4 form-label">{t('Limit Per User')}</label>
                             <i
                              className='fas fa-info-circle text-success fs-5 mt-1 ms-1'
                              title={t('How many times the same person can use this coupon')}
                            ></i>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input type="number" name="limitPerUser" className="form-control mb-2" min={1} placeholder={t("Limit Per User")} value={limitPerUser} onChange={(e) => { setLimitPerUser(e.target.value); removeError("limitPerUser"); }} />
                            <div className='text-danger fw-bold'>{error[0].limitPerUser}</div>
                            {/* <!--end::Input--> */}
                          </div>
                          <div className="col-lg-4 my-3">
                            {/* <!--begin::Label--> */}
                            <label className="required fs-4 form-label">{t('Limit Per Coupon')}</label>
                            <i
                              className='fas fa-info-circle text-success fs-5 mt-1 ms-1'
                              title={t(
                                'Total number of times this coupon can be used by everyone together'
                              )}
                            ></i>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input type="number" name="limitPerCoupon" className="form-control mb-2" min={1} placeholder={t("Limit Per Coupon")} value={limitPerCoupon} onChange={(e) => { setLimitPerCoupon(e.target.value); removeError("limitPerCoupon"); }} />
                            <div className='text-danger fw-bold'>{error[0].limitPerCoupon}</div>
                            {/* <!--end::Input--> */}
                          </div>
                        </div>
                        {/* <!--end::Input group--> */}
                      </div>
                      {/* <!--end::Card body--> */}
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
              <div className="d-flex justify-content-end">
                {/* <!--begin::Button--> */}
                <Link to="../viewhotelcouponlist/" id="kt_ecommerce_add_product_cancel" className="btn btn-light me-5">{t('Cancel')}</Link>
                {/* <!--end::Button--> */}
                <button type="button" disabled={disable} className="btn btn-primary" onClick={saveCouponApiCall}>
                  <span className="indicator-label">{t('Save')}</span>
                  {loading && (
                    <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                  )}
                </button>
                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export { AddCarCoupon }
